import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { TextField } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import no_image_available from "../../../../assets/img/no_image_available.svg";

const PropertyComponent = ({ onPropertyChange, partnerLogo, hasWritePermission }) => {
  const { t } = useTranslation();

  const [logo, setLogo] = useState(partnerLogo.logoUrl);
  const defaultLogo = no_image_available;

  useEffect(() => {
    setLogo(partnerLogo.logoUrl);
  }, [partnerLogo.logoUrl]);

  const onError = ev => {
    ev.target.src = defaultLogo;
  };

  return (
    <>
      <Grid key={0} item xs={12} lg={8}>
        <TextField
          variant="outlined"
          fullWidth
          id="partnerLogoUrl"
          value={partnerLogo.logoUrl || ""}
          name="logoUrl"
          label={t("Logo.LogoUrl")}
          onChange={onPropertyChange("logoUrl")}
          disabled={!hasWritePermission}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <div className="text-center">
          <div className="fileInput text-center">
            <div className="thumbnail">
              <img className="logo-image-edit" src={logo || defaultLogo} onError={onError} alt="..." />
            </div>
          </div>
        </div>
      </Grid>
    </>
  );
};

PropertyComponent.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  partnerLogo: PropTypes.object.isRequired,
  hasWritePermission: PropTypes.bool.isRequired
};

export default PropertyComponent;
